import React from 'react'
import EIdentificationApiContent from '../components/EIdentificationApi/EIdentificationApiContent'

const EIdentificationApi = (props) => {

  return (
    <>
        <EIdentificationApiContent following = {props.following === true ? true : false}/>
    </>
  )
}

export default EIdentificationApi